<template>
    <el-form :model="bizScope" :rules="bizScopeRules" ref="bizScopeForm" class="demo-ruleForm">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">业务范围名称</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="name">
                        <el-input v-model="bizScope.name" class="width-1-5x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>描述</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="desc">
                        <el-input class="width-2x" type="textarea" :rows="2" placeholder="请输入描述" v-model="bizScope.desc"></el-input>
                    </el-form-item>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>使用范围</span>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">业务单元类型</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="comLevel">
                        <el-radio-group v-model="bizScope.bizUnitType">
                            <el-radio class="radio" :label="3">总部</el-radio>
                            <el-radio class="radio" :label="0">普通</el-radio>
                            <el-radio class="radio" :label="1">门店</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
        </div>
        <!--        <div class="simple-form">-->
        <!--            <div class="form-group center">-->
        <!--                <div class="form-label">-->
        <!--                    <label class="required">是否门店专用</label>-->
        <!--                </div>-->
        <!--                <div class="form-value">-->
        <!--                    <el-form-item prop="shopFlag">-->
        <!--                        <el-radio-group v-model="bizScope.shopFlag" :disabled="bizScope.bizRefFlag && !copeBizPerm" @change="setBizPermOrgFlag()">-->
        <!--                            <el-radio class="radio mr10" :label="true">是</el-radio>-->
        <!--                            <el-radio class="radio" :label="false">否</el-radio>-->
        <!--                        </el-radio-group>-->
        <!--                    </el-form-item>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--            <div class="form-group center" v-if="!bizScope.shopFlag">-->
        <!--                <div class="form-label">-->
        <!--                    <label class="required">适用级别</label>-->
        <!--                </div>-->
        <!--                <div class="form-value">-->
        <!--                    <el-form-item prop="comLevel">-->
        <!--                        <el-radio-group v-model="bizScope.comLevel" :disabled="bizScope.bizRefFlag && !copeBizPerm">-->
        <!--                            <el-radio class="radio" :label="1">一级业务单元</el-radio>-->
        <!--                            <el-radio class="radio" :label="2">二级业务单元</el-radio>-->
        <!--                            <el-radio class="radio" :label="3">三级业务单元</el-radio>-->
        <!--                            <el-radio class="radio" :label="4">四级业务单元</el-radio>-->
        <!--                        </el-radio-group>-->
        <!--                    </el-form-item>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--            <div class="form-group center">-->
        <!--                <div class="form-label">-->
        <!--                    <label class="required">业务权限限制</label>-->
        <!--                </div>-->
        <!--                <div class="form-value">-->
        <!--                    <el-form-item prop="bizPermFlag">-->
        <!--                        <el-radio-group v-model="bizScope.bizPermFlag" @change="setBizPermOrgFlag()">-->
        <!--                            <el-radio class="radio mr10" :label="true">启用</el-radio>-->
        <!--                            <el-radio class="radio" :label="false">关闭</el-radio>-->
        <!--                        </el-radio-group>-->
        <!--                    </el-form-item>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--            <div class="form-group center" v-if="bizScope.bizPermFlag">-->
        <!--                <div class="form-label">-->
        <!--                    <label class="required">业务权限模式</label>-->
        <!--                </div>-->
        <!--                <div class="form-value">-->
        <!--                    <el-form-item prop="bizPermOrgFlag">-->
        <!--                        <el-radio-group v-model="bizScope.bizPermOrgFlag">-->
        <!--                            <el-radio class="radio" :label="1">仅本机构</el-radio>-->
        <!--                            &lt;!&ndash;<el-radio class="radio" :label="2">仅本部门</el-radio>&ndash;&gt;-->
        <!--                            <el-radio class="radio" :label="3" v-if="!bizScope.shopFlag">本机构及以下</el-radio>-->
        <!--                        </el-radio-group>-->
        <!--                    </el-form-item>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </div>-->
    </el-form>
</template>

<script>
import { Utils } from '../../app.base'
import { Vue, MsgBox, Routes } from '../../app.vues'

export default {
    name: 'swb-mercht-biz-perm-scope-save',
    desc: '业务范围',
    // copeBizPerm: 是否为复制模式
    props: ['item', 'copeBizPerm'],
    data: function () {
        let validateName = function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback(new Error('不可为空'));
            } else if(value.length > 60) {
                callback(new Error('最大长度60'));
            } else {
                callback()
            }
        };
        let validateDesc = function (rule, value, callback) {
            if(Utils.isNoB(value) || value.length < 250) {
                callback()
            } else {
                callback(new Error('最大长度250'));
            }
        };
        return {
            bizScope: {
                name: null,
                desc: null,
                shopFlag: true,
                comLevel: 1,
                comLevel1: false,
                comLevel2: false,
                comLevel3: false,
                comLevel4: false,
                bizPermFlag: false,
                bizPermOrgFlag: 1,
                bizUnitType: 3
            },
            bizScopeRules: {
                name: [{validator: validateName, trigger: 'blur'}],
                desc: [{validator: validateDesc, trigger: 'blur'}]
            }
        }
    },
    created: function () {
        let item = this.item;
        if(!Utils.isNoB(item) && item.id != null) {
            let bizScope = Utils.merge({}, item);
            if(Utils.isTrue(bizScope.comLevel1)) {
                bizScope.comLevel = 1;
            } else if(Utils.isTrue(bizScope.comLevel2)) {
                bizScope.comLevel = 2;
            } else if(Utils.isTrue(bizScope.comLevel3)) {
                bizScope.comLevel = 3;
            } else if(Utils.isTrue(bizScope.comLevel4)) {
                bizScope.comLevel = 4;
            }
            this.bizScope = bizScope;
        }
    },
    methods: {
        setBizPermOrgFlag: function () {
            let bizScope = this.bizScope;
            if(bizScope.shopFlag && bizScope.bizPermFlag) {
                bizScope.bizPermOrgFlag = 1;
            }
        },
        getDlgResult: function () {
            let self = this;
            let result = {};
            this.$refs['bizScopeForm'].validate(function (valid) {
                if(valid) {
                    let bizScope = self.bizScope;
                    if(!bizScope.shopFlag) {
                        // 开启门店 comLevel1-4 全部为 true; 所以需要重置
                        bizScope.comLevel1 = false;
                        bizScope.comLevel2 = false;
                        bizScope.comLevel3 = false;
                        bizScope.comLevel4 = false;
                        bizScope['comLevel' + bizScope['comLevel']] = true;
                    }
                    result.type = 'info';
                    result.data = bizScope;
                } else {
                    result.type = 'warn';
                    result.message = '校验失败';
                }
            });
            return result;
        }
    }
}
</script>





// WEBPACK FOOTER //
// src/compo/authx/MerchtBizPermScopeSave.vue